import _ from 'lodash';

export const mixinComputedDebug = {
  // evaluateForErrors is a debug function for development use only. It
  // goes through all computed values and stores whether or not any of them
  // returned an error.
  evaluateForErrors() {
    if (_.includes(_.get(this, '$vnode.tag'), '-El') ||
      _.includes(_.get(this, '$vnode.tag'), 'e-chart')) {
      return [];
    }

    const errors = [];
    _.forIn(_.get(this, '_computedWatchers'), (val, key) => {
      if (key !== 'evaluateForErrors') {
        try {
          _.get(this, key);
        } catch (err) {
          errors.push([key, err]);
        }
      }
    });

    return errors;
  },
};
